module.exports = __webpack_public_path__ + "img/IconaXLS_Color.c5e2534d.svg";